



























import Vue from "vue";
import {FitWxPhonex} from '@/fit-ui';
export default Vue.extend({
  name: "FitHalfScreenDialog",
  components:{
    FitWxPhonex
  },
  props: {
    title: String,
    visible: Boolean,
    maskClose: {
      type: Boolean,
      default: true
    },
    hideHeader: {
      type: Boolean,
      default: false,
    },
    appendToBody: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        // 弹窗打开时，添加类名禁止 body 滚动
        document.documentElement.classList.add('no-scroll');
        document.body.classList.add('no-scroll');
      } else {
        // 弹窗关闭时，移除类名恢复 body 滚动
        document.documentElement.classList.remove('no-scroll');
        document.body.classList.remove('no-scroll');
      }
    }
  },
  methods: {
    onClose() {
      this.$emit("onClose");
    },
    handleClickMask(e: Event) {
      // todo 为什么这里会报错
      // @ts-ignore
      if (e && e.target && e.target.id === "halfSelfDialog") {
        if (this.maskClose) {
          this.onClose();
        }
      }
    },
    stop(e: Event) {
      console.log(e);
      e.preventDefault();
    }
  },
  mounted() {
    if (this.appendToBody) {
      document.body.appendChild(this.$el);
    }
  },
  destroyed() {
    // 组件销毁时移除类名，恢复 body 滚动
    document.body.classList.remove('no-scroll');
    // if appendToBody is true, remove DOM node after destroy
    if (this.appendToBody && this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }
});
